module.exports = __webpack_public_path__ + "static/logo.20050646.png";